"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppHashRouterProviders = exports.SpaProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const SpaProviders = ({ basename, children }) => {
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { basename: basename, children: children });
};
exports.SpaProviders = SpaProviders;
const AppHashRouterProviders = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.HashRouter, { children: children });
};
exports.AppHashRouterProviders = AppHashRouterProviders;
//# sourceMappingURL=providers.js.map